import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { AnalyticsStep } from '@atlaskit/adf-schema/steps';
export function getAnalyticsEventsFromTransaction(tr) {
  return tr.steps.filter(function (step) {
    return step instanceof AnalyticsStep;
  }).reduce(function (acc, step) {
    return [].concat(_toConsumableArray(acc), _toConsumableArray(step.analyticsEvents));
  }, []);
}